module.exports = __webpack_public_path__ + "static/SweetAlert2-f7b1e3e25c68bf5de21e16a5a0ac8c38.png";